document.addEventListener('DOMContentLoaded', () => {
  // ----------------------------
  // Helpers
  // ----------------------------

  // Keep only the "base" search params (search term, search options, sort, etc.)
  // and drop filter params, pagination, and section bits.
  function getBaseSearchParams() {
    const keep = new URLSearchParams();
    const current = new URLSearchParams(window.location.search);

    current.forEach((value, key) => {
      const k = key.toLowerCase();

      // Remove all filter params and pagination/section noise
      const isFilter = k.startsWith('filter.');
      const isPage   = k === 'page';
      const isSect   = k === 'section_id';
      const isView   = k === 'view';

      if (isFilter || isPage || isSect || isView) return;

      // Keep everything else (q, type, options[prefix], sort_by, etc.)
      keep.append(key, value);
    });

    return keep;
  }

  // Returns current URL params excluding internal keys we control.
  function getNonInternalParamsFrom(urlSearchParamsLike) {
    const src = urlSearchParamsLike
      ? new URLSearchParams(urlSearchParamsLike)
      : new URLSearchParams(window.location.search);

    ['section_id', 'page', 'view'].forEach(k => src.delete(k));
    return src.toString(); // may be ""
  }

  // ----------------------------
  // Accordions
  // ----------------------------
  function initExclusiveAccordion() {
    document.querySelectorAll("details").forEach((detail) => {
      detail.addEventListener("toggle", function () {
        if (detail.open) {
          document.querySelectorAll("details").forEach((otherDetail) => {
            if (otherDetail !== detail) {
              otherDetail.removeAttribute("open");
            }
          });
        }
      });
    });
  }
  initExclusiveAccordion();

  // ----------------------------
  // Price slider
  // ----------------------------
  function initPriceSlider() {
    const rangeMin = document.getElementById('priceRangeMin');
    if (!rangeMin) return;

    const rangeMax = document.getElementById('priceRangeMax');
    const outputMin = document.getElementById('priceMinOutput');
    const outputMax = document.getElementById('priceMaxOutput');
    const hiddenMin = document.getElementById('HiddenPriceMin');
    const hiddenMax = document.getElementById('HiddenPriceMax');
    const sliderRange = document.getElementById('sliderRange');
    const outputMinWrapper = document.getElementById('priceMinOutputWrapper');
    const outputMaxWrapper = document.getElementById('priceMaxOutputWrapper');
    const clearBtn = document.getElementById('clear_price_range');
    const selected_result = document.getElementById('range_filter_selected_result');

    const minGap = 1;
    const sliderMinValue = parseInt(rangeMin.min);
    const sliderMaxValue = parseInt(rangeMin.max);

    function updateSlider(event) {
      let minVal = parseInt(rangeMin.value);
      let maxVal = parseInt(rangeMax.value);

      if (maxVal - minVal <= minGap) {
        if (event && event.target === rangeMin) {
          rangeMin.value = maxVal - minGap;
          minVal = parseInt(rangeMin.value);
        } else {
          rangeMax.value = minVal + minGap;
          maxVal = parseInt(rangeMax.value);
        }
      }

      outputMin.textContent = minVal;
      outputMax.textContent = maxVal;
      hiddenMin.value = minVal;
      hiddenMax.value = maxVal;

      const minPercent = (minVal / sliderMaxValue) * 100;
      const maxPercent = (maxVal / sliderMaxValue) * 100;

      outputMinWrapper.style.left = `calc(${minPercent}%)`;
      outputMinWrapper.style.transform = `translateX(calc(-${minPercent}%))`;
      outputMaxWrapper.style.left = `calc(${maxPercent}%)`;
      outputMaxWrapper.style.transform = `translateX(calc(-${maxPercent}% + 10%))`;
      sliderRange.style.left = minPercent + "%";
      sliderRange.style.width = (maxPercent - minPercent) + "%";

      if (minVal !== sliderMinValue || maxVal !== sliderMaxValue) {
        hiddenMin.setAttribute("name", "filter.v.price.gte");
        hiddenMax.setAttribute("name", "filter.v.price.lte");
        clearBtn?.classList.remove("clear_disable");
        selected_result?.classList.remove("hidden");
      } else {
        hiddenMin.removeAttribute("name");
        hiddenMax.removeAttribute("name");
        clearBtn?.classList.add("clear_disable");
        selected_result?.classList.add("hidden");
      }
    }

    rangeMin.addEventListener("input", updateSlider);
    rangeMax.addEventListener("input", updateSlider);

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        rangeMin.value = sliderMinValue;
        rangeMax.value = sliderMaxValue;
        updateSlider();
        applyFilters();
      });
    }

    updateSlider();
  }
  initPriceSlider();

  // ----------------------------
  // Filter Drawer (mobile)
  // ----------------------------
  const filterToggleBtn = document.querySelector('.filter-toggle-btn');
  const filtersSidebar = document.getElementById('filtersSidebar');
  const filtersOverlay = document.getElementById('filtersOverlay');
  const filtersCloseBtns = document.querySelectorAll('.filters-close-btn');

  function closeFilters() {
    document.getElementById('filtersSidebar')?.classList.remove('open');
    document.getElementById('filtersOverlay')?.classList.remove('active');
    document.body.classList.remove('filter_drawer-open');
  }

  if (filterToggleBtn && filtersSidebar && filtersOverlay) {
    filterToggleBtn.addEventListener('click', () => {
      filtersSidebar.classList.add('open');
      filtersOverlay.classList.add('active');
      document.body.classList.add('filter_drawer-open');
    });
  }

  if (filtersCloseBtns.length > 0) {
    filtersCloseBtns.forEach(button => {
      button.addEventListener('click', closeFilters);
    });
  }

  if (filtersOverlay) {
    filtersOverlay.addEventListener('click', closeFilters);
  }

  // ----------------------------
  // Grid / Infinite Scroll
  // ----------------------------
  const productGrid = document.querySelector('.nplp-collection-grid');
  const loader = document.getElementById('global-loader');
  let currentPage = 1;
  let isLoading = false;
  let maxPages = 0;
  // initialize with current URL params so first scroll after search includes q=...
  let activeSearchParams = getNonInternalParamsFrom();
  let onScroll = null;

  function setupInfiniteScroll() {
    if (!productGrid) {
      console.warn('productGrid not found.');
      return;
    }

    maxPages = parseInt(productGrid.dataset.maxPages, 10) || 0;

    if (onScroll) {
      window.removeEventListener('scroll', onScroll);
    }

    onScroll = () => {
      if (isLoading || currentPage >= maxPages) return;

      if (productGrid.getBoundingClientRect().bottom <= window.innerHeight + 200) {
        isLoading = true;
        currentPage++;

        const qs = activeSearchParams ? `&${activeSearchParams}` : '';
        fetch(`${window.location.pathname}?section_id=main-search&page=${currentPage}${qs}`)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newGrid = doc.querySelector('.nplp-collection-grid');

            if (!newGrid || !newGrid.hasChildNodes()) {
              window.removeEventListener('scroll', onScroll);
              if (loader) loader.style.display = 'none';
              return;
            }

            newGrid.childNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                productGrid.appendChild(node);

                if (node.classList.contains('nplp-product-card')) {
                  try {
                    initializeProductCard(node);
                  } catch (err) {
                    console.warn('Failed to initialize product card:', node, err);
                  }
                }
              }
            });
            maxPages = parseInt(newGrid.dataset.maxPages, 10) || maxPages;
          })
          .catch(console.error)
          .finally(() => {
            isLoading = false;
          });
      }
    };

    window.addEventListener('scroll', onScroll);
  }

  if (productGrid) {
    document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);
    setupInfiniteScroll();
  } else {
    console.warn('productGrid not found on DOMContentLoaded');
  }

  // ----------------------------
  // Cart + Product card init
  // ----------------------------
   function addToCart(variantId, parentEl) {
    parentEl.classList.remove('sizes_active');
    parentEl.classList.add('active_bag_loader');

    const btn = parentEl.querySelector('.nplp-bag-icon');

    // ---- Loader handling (attach BEFORE the network calls) ----
    // The spinner used to be cleared only by a rebuy:cart.change listener
    // attached AFTER /cart/add.js and /cart.js had both resolved. Two ways
    // that leaves it spinning forever: Rebuy can fire before the listener
    // exists and {once:true} never sees a missed event, and where Rebuy is
    // absent or disabled the event never comes at all. Same shape as the fix
    // already in product-card.js.
    let loaderCleared = false;
    const clearLoader = () => {
      if (loaderCleared) return;
      loaderCleared = true;
      parentEl.classList.remove('active_bag_loader');
      document.removeEventListener('rebuy:cart.change', onRebuyChange);
      document.removeEventListener('rebuy:cart.add', onRebuyChange);
      clearTimeout(fallbackTimeout);
    };
    function onRebuyChange() { clearLoader(); }
    document.addEventListener('rebuy:cart.change', onRebuyChange, { once: true });
    document.addEventListener('rebuy:cart.add', onRebuyChange, { once: true });
    // Safety net for when Rebuy never fires (no widgets, app off, app error).
    const fallbackTimeout = setTimeout(clearLoader, 3000);
    // ---- End loader handling ----
    const payload = {
      items: [{
        id: Number(String(variantId).includes('gid://') ? String(variantId).split('/').pop() : variantId),
        quantity: 1,
        properties: {
          _section:    btn?.getAttribute('data-section')    || '',
          _widget:     btn?.getAttribute('data-widget')     || '',
          _experience: btn?.getAttribute('data-experience') || '',
          _template:   btn?.getAttribute('data-template')   || ''
        }
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(() => fetch('/cart.js', { headers: { 'Accept': 'application/json' }}))
    .then(r => r.json())
    .then(cart => {
      const vid = payload.items[0].id; // normalized numeric variant id
      const line = [...cart.items].reverse().find(i => Number(i.variant_id) === Number(vid));

      // --- push just these fields ---
      const qty       = 1;
      const currency  = window.Shopify?.currency?.active || 'USD';
      const name      = line?.product_title || line?.title || String(vid);
      const unitPrice = line ? +(Number(line.final_price ?? line.price ?? 0) / 100).toFixed(2) : undefined;
      const variant   = line?.variant_title || undefined;
      const value     = unitPrice != null ? +(unitPrice * qty).toFixed(2) : undefined;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          ...(value != null ? { value } : {}),
          items: [{
            item_id:   String(vid),     // variant id (as requested)
            item_name: name,
            ...(unitPrice != null ? { price: unitPrice } : {}),
            quantity:  qty,
            ...(variant ? { item_variant: variant } : {})
          }]
        }
      });
      // -----------------------------

      // The add succeeded, so drop the spinner now rather than waiting on
      // Rebuy. clearLoader() is idempotent, so a later event is harmless.
      clearLoader();
    })
    .catch(err => {
      console.error('addToCart error:', err);
      clearLoader();
    });
  }

  function initializeProductCard(card) {
    const productId = card.dataset.productId;
    const variants = JSON.parse(card.querySelector('.product-variant-data').textContent);
    const materialInputs = card.querySelectorAll('.nplp-material-swatch input');
    const sizesDiv = card.querySelector('.nplp-size-swatches');
    const variantTitle = card.querySelector('.nplp-variant-title');
    const sizeParent = card.querySelector('.nplp-add-to-cart-wrapper');

const renderSizes = (material) => {
  const uniqueSizes = [...new Set(variants.map(v => v.option2))];
  sizesDiv.innerHTML = '';
  sizesDiv.innerHTML += `<p class="choose-option-label">Choose Size</p>`;

  if (uniqueSizes.length > 1) {
    sizeParent.classList.add('nplp-multiple-sizes');
  } else {
    sizeParent.classList.remove('nplp-multiple-sizes');
  }

  // Track if we rendered at least 1 usable swatch
  let renderedAny = false;

  uniqueSizes.forEach(sizeValue => {
    const matchingVariant = variants.find(v => v.option1 === material && v.option2 === sizeValue);
    const isAvailable = matchingVariant?.available;
    const variantId = matchingVariant?.id || '';

    // only count "usable" when it has an id and is available
    if (variantId && isAvailable) renderedAny = true;

    sizesDiv.innerHTML += `
      <label class="nplp-size-swatch ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}">
        <input type="radio" name="size-${productId}" value="${sizeValue}"
          ${variantId ? `data-variant-id="${variantId}"` : ''}
          ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}>
        <span>${sizeValue}</span>
      </label>
    `;
  });

  // ✅ FALLBACK: inject default variant if nothing usable exists (Default Title products)
  if (!renderedAny) {
    const v = variants?.find(x => x?.available) || variants?.[0];
    const defaultId = v?.id;

    if (defaultId) {
      sizesDiv.innerHTML = `
        <label class="nplp-size-swatch" style="display:none;">
          <input type="radio"
                 name="size-${productId}"
                 value="Default"
                 data-variant-id="${defaultId}">
          <span>Default</span>
        </label>
      `;
      sizeParent.classList.remove('nplp-multiple-sizes');
    } else {
      console.warn('[renderSizes fallback] No default variant id found', { variants, productId });
    }
  }
};

    // Swap the rendered price pair for the chosen material. The markup comes
    // from a <template> that Liquid filled, one entry per material, so money
    // formatting matches the active market exactly -- Shopify.formatMoney is
    // not available here and prices vary per market.
    const pricePair = card.querySelector('.nplp-card-price-pair');
    const priceVariants = card.querySelector('.nplp-card-price-variants');

    const updatePrice = (material) => {
      if (!pricePair || !priceVariants) return;
      if (pricePair.dataset.material === material) return;
      const entry = [...priceVariants.content.children].find(
        el => el.dataset.material === material
      );
      if (!entry) return;   // leave the current price rather than blanking it
      pricePair.innerHTML = entry.innerHTML;
      pricePair.dataset.material = material;
    };

    const defaultMaterial = materialInputs[0]?.value;
    if (defaultMaterial) updatePrice(defaultMaterial);
    if (defaultMaterial) renderSizes(defaultMaterial);
    if (!defaultMaterial) renderSizes(variants?.[0]?.option1 || '');

    materialInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedMaterial = input.value;

        // Convert to handle format
        const selectedMaterialHandle = selectedMaterial
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');

        variantTitle.textContent = selectedMaterial;
        renderSizes(selectedMaterial);
        updatePrice(selectedMaterial);

        const matchingVariant = variants.find(v => v.option1 === selectedMaterial);
        const splideElement = card.querySelector('.nplp-product-slider');
        const mainImg = splideElement?.querySelector('.product-main-image');
        const hoverImg = splideElement?.querySelector('.product-hover-image');

        const mainImageFullSrc = matchingVariant?.featured_image?.src
          ? 'https:' + matchingVariant.featured_image.src.split('?')[0]
          : '';

        if (mainImageFullSrc && mainImg) {
          mainImg.src = mainImageFullSrc;
          mainImg.alt = selectedMaterialHandle;
        }

        const imagesData = JSON.parse(card.querySelector('.product-all-images')?.textContent || '[]');

        const normalize = (url) => {
          try {
            return new URL(url, window.location.origin).pathname;
          } catch {
            return url?.split('?')[0] || '';
          }
        };

        const normalizedMainImage = normalize(mainImageFullSrc);

        let hoverImageData = imagesData.find(img => {
          const fullSrc = 'https:' + img.src;
          const normalizedHover = normalize(fullSrc);
          const matchesAlt = img.alt.includes(selectedMaterialHandle) && img.alt.includes('model');
          const isDifferent = normalizedHover !== normalizedMainImage;
          return matchesAlt && isDifferent;
        });

        if (!hoverImageData) {
          hoverImageData = imagesData.find(img => {
            const fullSrc = 'https:' + img.src;
            const normalizedHover = normalize(fullSrc);
            const matchesAlt = img.alt.includes(selectedMaterialHandle);
            const isDifferent = normalizedHover !== normalizedMainImage;
            return matchesAlt && isDifferent;
          });
        }
        if (hoverImg && hoverImageData) {
          hoverImg.src = 'https:' + hoverImageData.src;
          hoverImg.alt = hoverImageData.alt;
        }
      });
    });

    card.querySelector('.nplp-bag-icon')?.addEventListener('click', e => {
      e.stopPropagation();
      const bagIcon = e.currentTarget;
      const parentEl = bagIcon.closest('.nplp-add-to-cart-wrapper');
      const visibleSizes = sizesDiv.querySelectorAll('.nplp-size-swatch');
      if (visibleSizes.length <= 1) {
        const singleVariant = visibleSizes[0]?.querySelector('input');
        if (singleVariant) addToCart(singleVariant.dataset.variantId, parentEl);
      } else {
        sizesDiv.classList.toggle('show');
        parentEl.classList.toggle('sizes_active');
        const handleOutsideClick = (event) => {
          if (!sizesDiv.contains(event.target) && !card.querySelector('.nplp-bag-icon').contains(event.target)) {
            sizesDiv.classList.remove('show');
            parentEl.classList.remove('sizes_active');
            document.removeEventListener('click', handleOutsideClick);
          }
        };
        if (sizesDiv.classList.contains('show')) {
          document.addEventListener('click', handleOutsideClick);
        }
      }
    });

    sizesDiv.addEventListener('change', e => {
      const variantId = e.target.dataset.variantId;
      const parentEl = sizesDiv.closest('.nplp-add-to-cart-wrapper');
      sizesDiv.classList.remove('show');
      if (variantId) addToCart(variantId, parentEl);
    });

    const splideElement = card.querySelector('.nplp-product-slider');
    const index = parseInt(splideElement?.dataset.index || '0', 10);

    function initializeResponsiveSlider(card, index) {
      const splideElement = card.querySelector('.nplp-product-slider');
      if (!splideElement) return;

      let splideInstance = null;

      const setupSplide = () => {
        const isMobile = window.innerWidth < 992;

        if (isMobile && !splideElement.classList.contains('is-mounted')) {
          splideInstance = new Splide(splideElement, {
            type: 'loop',
            perPage: 1,
            arrows: false,
            pagination: true,
            clones: 0,
            drag: true,
            swipeThreshold: 20,
            flickPower: 500,
          });

          splideInstance.mount();
          splideElement.classList.add('is-mounted');

          const slides = splideElement.querySelectorAll('.splide__slide');
          let firstSlideIndex = 0;
          slides.forEach((slide, idx) => {
            if (slide.classList.contains('first__slide')) {
              firstSlideIndex = idx;
            }
          });
          splideInstance.go(firstSlideIndex);
        }

        if (!isMobile && splideElement.classList.contains('is-mounted')) {
          splideInstance?.destroy();
          splideElement.classList.remove('is-mounted');
        }
      };

      setupSplide();
      window.addEventListener('resize', setupSplide);
    }

    initializeResponsiveSlider(card, index);
  }

  // ----------------------------
  // Filters (preserving q)
  // ----------------------------
  const filterForm = document.querySelector('#FacetFiltersForm');

  // Global base params snapshot; refreshed on every apply
  let BASE_SEARCH_PARAMS = getBaseSearchParams(); // preserves ?q=... & related options

  function initializeResetButtons() {
    document.querySelectorAll('.facets__reset').forEach(button => {
      button.addEventListener('click', function () {
        const targetName = this.getAttribute('data-target');
        if (!targetName) return;

        const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${targetName}"]`);
        checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });

        applyFilters();
      });
    });
  }

  function initializeClearAllFilters() {
    const clearAllButtons = document.querySelectorAll('.clear_all_filter');
    if (!clearAllButtons.length) return;

    clearAllButtons.forEach(button => {
      button.addEventListener('click', function () {
        applyFilters(true);
      });
    });
  }

  function initializeActiveFilterRemoval() {
    document.querySelectorAll('.specific_filter_remove').forEach(pill => {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        const url = this.getAttribute('href');
        applyFiltersFromUrl(url);
      });
    });
  }

  function applyFilters(clearAll = false) {
    const openAccordions = [];

    document.querySelectorAll('.disclosure-has-popup').forEach(acc => {
      if (acc.open) openAccordions.push(acc.getAttribute('data-filter-type'));
    });

    const collectionUrl = window.location.pathname;

    // Recompute base on each apply in case the user changed the query via the UI
    BASE_SEARCH_PARAMS = getBaseSearchParams();

    let url, newUrl;

    if (clearAll) {
      // Keep base params (q, type, options..., sort_by if you keep it)
      const merged = new URLSearchParams(BASE_SEARCH_PARAMS.toString());
      activeSearchParams = merged.toString();

      url    = `${collectionUrl}?section_id=main-search${activeSearchParams ? `&${activeSearchParams}` : ''}`;
      newUrl = `${collectionUrl}${activeSearchParams ? `?${activeSearchParams}` : ''}`;
    } else {
      // Merge base params + form filters
      const formData = new FormData(filterForm);
      const formParams = new URLSearchParams(formData);

      const merged = new URLSearchParams(BASE_SEARCH_PARAMS.toString());
      // Overwrite/append filter params on top of base
      for (const [k, v] of formParams.entries()) {
        if (v === '' || v == null) {
          merged.delete(k);
        } else {
          merged.delete(k);
          merged.append(k, v);
        }
      }

      activeSearchParams = merged.toString();
      url    = `${collectionUrl}?section_id=main-search&${activeSearchParams}`;
      newUrl = `${collectionUrl}?${activeSearchParams}`;
    }

    if (loader) loader.style.display = 'flex';
    history.pushState({}, '', newUrl);

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('.nplp-collection-grid');
        const newFacetForm = doc.querySelector('#FacetFiltersForm');

        if (productGrid && newGrid) productGrid.innerHTML = newGrid.innerHTML;
        if (filterForm && newFacetForm) filterForm.innerHTML = newFacetForm.innerHTML;

        if (productGrid && newGrid?.dataset.maxPages) {
          productGrid.dataset.maxPages = newGrid.dataset.maxPages;
          maxPages = parseInt(newGrid.dataset.maxPages, 10);
        }
        currentPage = 1;
        isLoading = false;

        openAccordions.forEach(type => {
          const acc = filterForm?.querySelector(`.disclosure-has-popup[data-filter-type="${type}"]`);
          if (acc) acc.open = true;
        });

        document.querySelectorAll('.sidebar_close_btn').forEach(button => {
          button.addEventListener('click', closeFilters);
        });

        initExclusiveAccordion();
        initPriceSlider();
        initializeClearAllFilters();
        initializeResetButtons();
        initializeActiveFilterRemoval();
        document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);

        setupInfiniteScroll();
        window.scrollTo(0, 0);
      })
      .catch(console.error)
      .finally(() => {
        if (loader) loader.style.display = 'none';
      });
  }

  function applyFiltersFromUrl(url) {
    const cleanUrl = new URL(url, window.location.origin);

    // keep q, drop internal
    activeSearchParams = getNonInternalParamsFrom(cleanUrl.searchParams);

    const fetchUrl = `${cleanUrl.pathname}?section_id=main-search${activeSearchParams ? `&${activeSearchParams}` : ''}`;

    if (loader) loader.style.display = 'flex';
    history.pushState({}, '', `${cleanUrl.pathname}${activeSearchParams ? `?${activeSearchParams}` : ''}`);

    fetch(fetchUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('.nplp-collection-grid');
        const newFacetForm = doc.querySelector('#FacetFiltersForm');

        if (productGrid && newGrid) productGrid.innerHTML = newGrid.innerHTML;
        if (filterForm && newFacetForm) filterForm.innerHTML = newFacetForm.innerHTML;

        if (productGrid && newGrid?.dataset.maxPages) {
          productGrid.dataset.maxPages = newGrid.dataset.maxPages;
          maxPages = parseInt(newGrid.dataset.maxPages, 10);
        }

        currentPage = 1;

        initExclusiveAccordion();
        initPriceSlider();
        initializeClearAllFilters();
        initializeResetButtons();
        initializeActiveFilterRemoval();
        document.querySelectorAll('.nplp-product-card').forEach(initializeProductCard);

        setupInfiniteScroll();

        window.scrollTo(0, 0);
      })
      .catch(console.error)
      .finally(() => {
        if (loader) loader.style.display = 'none';
      });
  }

  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      e.preventDefault();
      applyFilters();
    });

    initializeClearAllFilters();
    initializeResetButtons();
    initializeActiveFilterRemoval();

    if (window.location.href.includes('filter')) {
      applyFilters();
    }
  }
});
